import { DataAttributes, ProgressBar } from "@animech/ui";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { LoadingPanelProps } from "./loading-panel";

export type RootProps = DataAttributes<Pick<LoadingPanelProps, "variant">>;

export const ProgressWrapper = styled.div``;
export const Progress = styled(ProgressBar)``;

export const Root = styled.div<RootProps>`
	${({ theme }) => css`
		display: flex;
		position: absolute;
		top: 0;
		left: 0;
		align-items: center;
		justify-content: center;
		height: 100%;
		width: 100%;

		&[data-variant="solid"] {
			background: ${theme.app.panels.overlayBackground};
		}

		&[data-variant="backdrop"] {
			background: rgba(0, 0, 0, 0.3);
		}
	`}
`;
